import apiClient from './apiClient';

const API_BASE_URL = '/entitlements';

/**
 * Client for the unified entitlements endpoint (task #3782).
 *
 * The backend resolves the two-gate model (product then subscription) and
 * returns both maps so the frontend never reimplements the precedence.
 */
class EntitlementsService {
  /**
   * @returns {Promise<{product: Object.<string, boolean>, resolved: Object.<string, boolean>}>}
   *   product  ÔÇö product-level gate ("which modules this product has").
   *   resolved ÔÇö product AND subscription, per feature, for the caller's tenant.
   */
  async getEntitlements() {
    const response = await apiClient.get(API_BASE_URL);
    return response.data;
  }
}

export default new EntitlementsService();
